// Debug ride data for local testing of the courier flow.
// Access via URL: /DEBUG/rit/<jsonName>
// Mirrors the response of the ride endpoint (see examples/ride-response-1913.json).

export const rideDebugData = {
  'ride-1913': {
    "meta": { "status": "success" },
    "data": {
      "addresses": [
        {
          "itemType": "4",
          "key": "21424513",
          "processed": false,
          "deliveryItems": [
            { "verpakking": 167, "orderNumber": "2610286", "pakbon": "324236", "items": [21389058], "objectid": 21389058, "pallets": 0 },
            { "verpakking": 75, "orderNumber": "2610534", "pakbon": "324207", "items": [21398906], "objectid": 21398906, "pallets": 0 },
            { "verpakking": 50, "orderNumber": "2609860", "pakbon": "324249", "items": [21375582], "objectid": 21375582, "pallets": 0 },
            { "verpakking": 1, "orderNumber": "2610535", "pakbon": "324141", "items": [21398912], "objectid": 21398912, "pallets": 0 },
            { "verpakking": 1, "orderNumber": "2610227", "pakbon": "324152", "items": [21386074], "objectid": 21386074, "pallets": 1 },
            { "verpakking": 1, "orderNumber": "2610536", "pakbon": "324153", "items": [21398913], "objectid": 21398913, "pallets": 1 },
            { "verpakking": 6, "orderNumber": "2610541", "pakbon": "324209", "items": [21398925], "objectid": 21398925, "pallets": 0 },
            { "verpakking": 3, "orderNumber": "2610540", "pakbon": "324211", "items": [21398920], "objectid": 21398920, "pallets": 0 },
            { "verpakking": 20, "orderNumber": "2610530", "pakbon": "324210", "items": [21398832], "objectid": 21398832, "pallets": 0 },
            { "verpakking": 2, "orderNumber": "2610529", "pakbon": "324217", "items": [21398831], "objectid": 21398831, "pallets": 0 },
            { "verpakking": 12, "orderNumber": "2610527", "pakbon": "324252", "items": [21398804], "objectid": 21398804, "pallets": 0 },
            { "verpakking": 2, "orderNumber": "2610822", "pakbon": "324256", "items": [21408511], "objectid": 21408511, "pallets": 0 },
            { "verpakking": 2, "orderNumber": "2610824", "pakbon": "324255", "items": [21408526], "objectid": 21408526, "pallets": 0 },
            { "verpakking": 7, "orderNumber": "2610826", "pakbon": "324163", "items": [21408550], "objectid": 21408550, "pallets": 0 },
            { "verpakking": 2, "orderNumber": "2610833", "pakbon": "324218", "items": [21408638], "objectid": 21408638, "pallets": 0 },
            { "verpakking": 2, "orderNumber": "2610834", "pakbon": "324214", "items": [21408639], "objectid": 21408639, "pallets": 0 },
            { "verpakking": 14, "orderNumber": "2610835", "pakbon": "324241", "items": [21408640], "objectid": 21408640, "pallets": 0 },
            { "verpakking": 2, "orderNumber": "2610836", "pakbon": "324216", "items": [21408643], "objectid": 21408643, "pallets": 0 },
            { "verpakking": 2, "orderNumber": "2611024", "pakbon": "324253", "items": [21412981], "objectid": 21412981, "pallets": 0 }
          ],
          "verpakking": 241,
          "levertijd": "",
          "status": "Deellevering",
          "undeliverable": false,
          "opmerking": "",
          "delivered": false,
          "afleverLandcode": "NL",
          "afleverDatum": "09-09-2026",
          "deliveryitem": [21389058, 21398906, 21375582, 21398912, 21386074, 21398913, 21398925, 21398920, 21398832, 21398831, 21398804, 21408511, 21408526, 21408550, 21408638, 21408639, 21408640, 21408643, 21412981],
          "levDatHard": "true",
          "afleverAdres": "Earl Bakkenstraat",
          "afleverPostcode": "6422 PJ",
          "afleverNaam": "Medtronic International Trading Sàrl",
          "afleverLand": "NEDERLAND",
          "pallets": 7,
          "afleverHuisNr": "10",
          "afleverPersoon": "Stores - Raw Materials",
          "afleverLine4": "",
          "afleverLine3": "",
          "afleverLine2": "",
          "afleverLine1": "",
          "afleverPlaats": "HEERLEN"
        },
        {
          "itemType": "4",
          "key": "21424599",
          "processed": false,
          "deliveryItems": [
            { "verpakking": 4, "orderNumber": "2610900", "pakbon": "324300", "items": [21400001], "objectid": 21400001, "pallets": 0 },
            { "verpakking": 2, "orderNumber": "2610901", "pakbon": "324301", "items": [21400002], "objectid": 21400002, "pallets": 1 }
          ],
          "verpakking": 6,
          "levertijd": "12:00",
          "status": "Deellevering",
          "undeliverable": false,
          "opmerking": "Melden bij de portier, laaddok aan de achterzijde.",
          "delivered": false,
          "afleverLandcode": "NL",
          "afleverDatum": "09-09-2026",
          "deliveryitem": [21400001, 21400002],
          "levDatHard": "true",
          "afleverAdres": "Afrikalaan",
          "afleverPostcode": "6199 AH",
          "afleverNaam": "Testadres met opmerking en levertijd",
          "afleverLand": "NEDERLAND",
          "pallets": 1,
          "afleverHuisNr": "40",
          "afleverPersoon": "Receptie",
          "afleverLine4": "",
          "afleverLine3": "",
          "afleverLine2": "",
          "afleverLine1": "",
          "afleverPlaats": "MAASTRICHT-AIRPORT"
        },
        {
          "itemType": "4",
          "key": "21424511",
          "processed": true,
          "deliveryItems": [
            { "verpakking": 1, "orderNumber": "2610310", "pakbon": "324232", "items": [21389327], "objectid": 21389327, "pallets": 0 }
          ],
          "verpakking": 1,
          "levertijd": "",
          "status": "Geleverd",
          "undeliverable": false,
          "opmerking": "",
          "delivered": true,
          "afleverLandcode": "NL",
          "afleverDatum": "09-09-2026",
          "deliveryitem": [21389327],
          "levDatHard": "false",
          "afleverAdres": "Earl Bakkenstraat",
          "afleverPostcode": "6422 PJ",
          "color": "#7ED321",
          "afleverNaam": "Medtronic Distribution Center",
          "afleverLand": "NEDERLAND",
          "pallets": 0,
          "afleverHuisNr": "7",
          "afleverPersoon": "HRL 3 | Kitting | DOCK 23",
          "afleverLine4": "",
          "afleverLine3": "",
          "afleverLine2": "",
          "afleverLine1": "",
          "afleverPlaats": "HEERLEN"
        }
      ],
      "ride": {
        "rideId": "088DB3BA-6265-49E7-9A40-1AC6FF144274",
        "deliveryDate": "09-09-2026",
        "rideNumber": "1913"
      },
      "carrier": {
        "name": "Koerier",
        "carrierId": "B25075EF-A2CD-430A-99A3-229B1E2BFB22"
      }
    }
  }
};
